// extracted by mini-css-extract-plugin
export default {"image":"ViewImages_image__LK3yX","modal":"ViewImages_modal__q-b0N"};